const allowedStatuses = ['not-available', 'unknown', 'ok', 'warn', 'alert']

export default allowedStatuses
